import React from 'react'
import PropTypes from 'prop-types'
import HelpItem from './help_item'

const HelpComponent = ({ helpItems }) => {
  return (
    <div className='help-container'>
      {helpItems.map((value, index) => <HelpItem key={index} item={value} position={index} />)}
    </div>
  )
}

HelpComponent.propTypes = {
  helpItems: PropTypes.array,
}

export default HelpComponent
